import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import cx from 'classnames';

import { Row } from '../../../../atoms/row/Row';
import { Radio } from '../../../../atoms/radio/Radio';
import { Close } from '../../../../../../static/icons/close';

import SystemguideAnswerAccordion from '../../../../atoms/systemguide-answer-accordion/SystemguideAnswerAccordion';

import useAnswerChange from '../useAnswerChange';

const RadioQuestion = ({
  answers,
  questionId,
  formName,
  locale,
  required = false,
  horizontal = false,
  clearVisible = false,
  minimizeRows = false,
  hasColumns = false,
}) => {
  const { setValue, control } = useFormContext();
  const { currentName, getCurrentAnswerObject, handleChangeRadio } =
    useAnswerChange(questionId, formName);

  const clearValue = () => {
    setValue(currentName, '');
  };

  return (
    <div className="flex w-full flex-col md:flex-row gap-3">
      <div
        className={`${
          hasColumns
            ? `grid grid-cols-2 md:grid-cols-3 gap-3 w-full`
            : `flex w-full gap-3`
        } ${
          clearVisible
            ? 'justify-start'
            : !hasColumns && !minimizeRows
            ? 'justify-between'
            : ''
        } ${
          !hasColumns && horizontal
            ? 'flex-col md:flex-row'
            : !hasColumns && minimizeRows
            ? 'flex-wrap max-w-6xl justify-center'
            : !hasColumns
            ? 'flex-col'
            : ''
        }`}
      >
        <Controller
          control={control}
          name={currentName}
          rules={{ required }}
          render={({ field }) =>
            answers.map((answer) => {
              const answerId = answer.id;
              const currAnswerObj = getCurrentAnswerObject(answerId);

              if (answer.type === 'input') {
                return (
                  <Row
                    key={answerId}
                    className={`w-full py-3 ${
                      horizontal ? 'w-full md:w-fit px-4' : 'pl-4 pr-6'
                    } bg-[#EAF5FB] rounded-3xl gap-3 global-hover items-center`}
                  >
                    <input
                      onChange={(e) =>
                        handleChangeRadio(answer, e.target.value)
                      }
                      value={currAnswerObj?.text || ''}
                      className="pl-4 pr-10 w-full py-2 border border-customGray-400 text-customGray-700 placeholder-customGray-400 focus:placeholder-opacity-60 rounded-lg bg-transparent focus:outline-none"
                    />
                  </Row>
                );
              }

              if (hasColumns) {
                const isSelected = currAnswerObj?.answerId === answerId;
                return (
                  <div
                    className={cx(
                      'flex bg-[#EAF5FB] flex-col-reverse justify-center rounded-3xl gap-1 global-hover py-4 pl-4 pr-6 sm:flex-row sm:gap-2',
                      {
                        'items-center justify-center': true, // CSS needed to fix layout after removing radiobutton
                        'bg-primary-700': isSelected, // CSS needed to fix layout after removing radiobutton
                      }
                    )}
                    key={answerId}
                    onClick={() => handleChangeRadio(answer, '')}
                  >
                    {/*
                      <Radio
                        value={answerId}
                        name={currentName}
                        checked={currAnswerObj?.answerId === answerId}
                        onChange={() =>
                          handleChangeRadio(answer, '', field.onChange)
                        }
                      />
                    ) */}

                    <SystemguideAnswerAccordion
                      text={answer.texts[locale] || answer.specialName}
                      textsHelp={answer.textsHelp[locale]}
                      textAlign="center"
                      textClassName={isSelected ? '!text-white' : undefined}
                    />
                  </div>
                );
              }

              if (minimizeRows) {
                return (
                  <div className="bg-[#EAF5FB] rounded-3xl">
                    <div className="flex w-full py-4 gap-3">
                      <Radio
                        value={answerId}
                        name={currentName}
                        checked={currAnswerObj?.answerId === answerId}
                        onChange={() =>
                          handleChangeRadio(answer, '', field.onChange)
                        }
                      />

                      <SystemguideAnswerAccordion
                        text={answer.texts[locale] || answer.specialName}
                        textsHelp={answer.textsHelp[locale]}
                      />
                    </div>
                  </div>
                );
              }

              return (
                <Row
                  key={answerId}
                  onClick={() => handleChangeRadio(answer, '')}
                  className={`w-full py-4 ${
                    horizontal ? 'w-full md:w-fit px-4' : 'pl-4 pr-6'
                  } bg-[#EAF5FB] rounded-3xl gap-3 global-hover items-center`}
                >
                  <Radio
                    value={answerId}
                    name={currentName}
                    checked={currAnswerObj?.answerId === answerId}
                    onChange={() =>
                      handleChangeRadio(answer, '', field.onChange)
                    }
                  />

                  <SystemguideAnswerAccordion
                    text={answer.texts[locale]}
                    textsHelp={answer.textsHelp[locale]}
                  />
                </Row>
              );
            })
          }
        />
      </div>

      {clearVisible && (
        <button
          type="button"
          onClick={clearValue}
          aria-label="Close"
          className="flex w-9 h-9 self-start md:self-center justify-center items-center border border-customGray-300 rounded-full global-hover"
        >
          <Close width={18} height={18} />
        </button>
      )}
    </div>
  );
};

export default RadioQuestion;
